import styled from "styled-components";

const MainHome = styled.main`

`;

export {
    MainHome,

}